<template>
  <div class="HomeAccomp">
    <div class="HomeAccomp-Container">
      <div class="HomeAccomp-Jobstream">
        <Title>Formation</Title>
        <Title type="small">La formation sur mesure</Title>
        <Spacer></Spacer>
        <Spacer></Spacer>
        <div class="HomeAccomp-Text">
          <Paragraph>
            <strong>JobStream</strong> vous propose une approche différenciante en 3 étapes pour une formation 100% adaptée à vos besoins.
          </Paragraph>
        </div>
        <router-link to="/formation" @click.native="$scrollToTop();">
          <div class="HomeAccomp-Button">
            <Animation>
              <Button>Voir plus</Button>
            </Animation>
          </div>
        </router-link>
      </div>
      <Animation :delay="500">
        <div class="HomeAccomp-Images">
          <div class="HomeAccompCircles">
            <div class="HomeAccompCircle-Big"></div>
            <div class="HomeAccompCircle-Little"></div>
          </div>
          <div class="HomeAccomp-Images-Circles">
            <div class="Circle Circle0">
              <img src="/img/global/interview.svg" alt="Icon Interview"/>
            </div>
            <div class="Circle Circle1">
              <div class="GreenCircle GreenCircle1"></div>
              <img src="/img/home/man-happy2.png" alt="Man Happy"/>
            </div>
            <div class="Circle Circle2">
              <img src="/img/global/search.svg" alt="Icon Search"/>
            </div>
            <div class="Circle Circle3">
              <div class="GreenCircle GreenCircle3"></div>
              <img src="/img/home/woman-happy2.png" alt="Woman Happy"/>
            </div>
            <div class="Circle Circle4">
              <img src="/img/global/group.svg" alt="Icon Group"/>
            </div>
          </div>
          <div class="HomeAccomp-Central-Image">
            <img src="/img/home/Woman-Smilling-Computer.png" alt="Woman Smilling Computer"/>
          </div>
        </div>
      </Animation>
    </div>
  </div>
</template>

<script>
import Paragraph from "../paragraph/Paragraph";

export default {
  name: "HomeAccomp",
  components: {Paragraph}
}
</script>

<style scoped>
/* 
* Global 
*/
.HomeAccomp-Container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  background-size: 1650px;
  background-position: left -75px bottom;
  padding-top: 100px;
}

.HomeAccomp-Jobstream {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  padding-right: 150px;
  position: relative;
  top: -100px;
}

.HomeAccomp-Jobstream >>> .Paragraph {
  padding: 0 25px;
}

a {
  text-decoration: none;
  color: white;
}

/*
* Background 
*/
.HomeAccomp-Background img {
  opacity: 0.05;
}

/* 
* Text 
*/
.HomeAccomp-Text {
  color: rgba(0, 0, 0, 0.5);
  text-align: center;
  max-width: 400px;
  margin: 0 auto 50px auto;
}

.HomeAccomp-Title {
  font-size: 26px;
}

.HomeAccomp-TitleGreen {
  font-size: 12px;
  margin-bottom: 50px;
}

/* 
* Button 
*/
.HomeAccomp-Button >>> .Button {
  width: 100px;
  text-align: center;
}


.HomeAccomp-Images {
  position: relative;
  height: 700px;
}

.HomeAccompCircles, .HomeAccomp-Images {
  position: relative;
}

.HomeAccompCircle-Little, .HomeAccompCircle-Big {
  border-radius: 50%;
}

.HomeAccompCircle-Little {
  position: absolute;
  width: 300px;
  height: 300px;
  background-color: rgba(0, 145, 155, 0.35);
  left: 155px;
  top: 140px;
}

.HomeAccompCircle-Big {
  width: 600px;
  height: 600px;
  background-color: transparent;
  border: 4px solid #00919B;
}

.HomeAccomp-Central-Image {
  position: absolute;
  top: 128px;
  left: 135px;
}

.HomeAccomp-Central-Image img {
  width: 500px;
}

.HomeAccomp-Images-Circles {
  position: absolute;
}

.Circle0 {
  top: -190px;
  left: -5px;
  width: 125px;
  height: 125px;
}

.Circle0 img {
  width: 50px;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.Circle {
  background-color: #FFFFFF;
  box-shadow: 0px 10px 30px 5px rgba(119, 119, 119, 0.25);
  position: absolute;
  z-index: 3;
  border-radius: 50%;
}

.Circle1 {
  top: -450px;
  left: -25px;
  width: 100px;
  height: 100px;
}

.Circle1 img {
  width: 90px;
  position: relative;
  left: 49%;
  top: -73%;
  border-radius: 100%;
  transform: translateX(-50%);
}

.GreenCircle {
  background-color: #00919B;
  border-radius: 50%;
  position: relative;
  left: 50%;
  top: 5%;
  transform: translateX(-50%);
}

.GreenCircle1 {
  width: 90px;
  height: 90px;
}

.Circle2 {
  top: -620px;
  left: 145px;
  width: 75px;
  height: 75px;
}

.Circle2 img {
  width: 30px;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.GreenCircle3 {
  width: 65px;
  height: 65px;
  top: 6% !important;
}

.Circle3 {
  top: -585px;
  left: 440px;
  width: 75px;
  height: 75px;
}

.Circle3 img {
  width: 40px;
  position: relative;
  left: 49%;
  top: -74%;
  border-radius: 38%;
  transform: translateX(-50%);
}

.Circle4 {
  top: -440px;
  left: 520px;
  width: 150px;
  height: 150px;
}

.Circle4 img {
  width: 60px;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

/* 
* Responsive
*/
@media (max-width: 1350px) {

  .HomeAccomp-Container {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-size: 865px;
    background-position: left 30% bottom -660px;
    padding-top: 50px;
  }

  .HomeAccomp-Jobstream {
    margin-bottom: 80px;
    padding-right: 0;
    top: 0px;
  }

  .HomeAccomp-Images {
    padding-left: 0;
    top: 0px;
    height: 700px;
  }

}

@media (max-width: 900px) {

  .HomeAccomp-Container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background-size: 865px;
    background-position: left 30% bottom -660px;
    padding-top: 0;
    padding-bottom: 0px;
  }

  .HomeAccomp-Images {
    width: 400px;
    height: 366px;
    position: relative;
  }

  .HomeAccompCircles {
    width: 100%;
    left: -70px;
  }

  .HomeAccomp-Images-Circles {
    width: 100%;
    left: -70px;
  }

  .HomeAccomp-Central-Image {
    top: 80px;
    left: 120px;
  }

  .HomeAccompCircle-Little {
    width: 150px;
    height: 150px;
    left: 195px;
    top: 85px;
  }

  .HomeAccompCircle-Big {
    width: 300px;
    height: 300px;
    position: absolute;
    top: 5px;
    left: 115px;
  }

  .HomeAccomp-Central-Image img {
    width: 250px;
  }

  .Rectangle {
    width: 100px;
    top: 185px;
    left: 90px;
    padding: 10px;
  }

  .Rectangle img {
    width: 25px;
  }

  .Rectangle p {
    font-size: 12px;
  }

  .Rectangle p:nth-of-type(1) {
    font-family: 'GothamBold', sans-serif;
    margin: 5px 0;
  }

  .Circle0 {
    top: 200px;
    left: 95px;
    width: 80px;
    height: 80px;
  }

  .Circle0 img {
    width: 45px;
    position: relative;
    left: 50%;
    top: 20%;
    transform: translateX(-50%);
  }

  .Circle1 {
    top: 55px;
    left: 100px;
    width: 70px;
    height: 70px;
  }

  .Circle1 img {
    width: 45px;
    position: relative;
    left: 50%;
    top: -69%;
    transform: translateX(-50%);
  }

  .GreenCircle1 {
    width: 60px;
    height: 60px;
    top: 5px;
  }

  .Circle2 {
    top: -10px;
    left: 210px;
    width: 50px;
    height: 50px;
  }

  .Circle2 img {
    width: 30px;
    position: relative;
    left: 50%;
    top: 20%;
    transform: translateX(-50%);
  }

  .GreenCircle3 {
    width: 45px;
    height: 45px;
    top: 4% !important;
    left: 25px;
  }

  .Circle3 {
    top: 20px;
    left: 345px;
    width: 50px;
    height: 50px;
  }

  .Circle3 img {
    width: 45px;
    position: relative;
    left: 50%;
    top: -85%;
    transform: translateX(-50%);
  }

  .Circle4 {
    top: 100px;
    left: 380px;
    width: 80px;
    height: 80px;
  }

  .Circle4 img {
    width: 45px;
    position: relative;
    left: 50%;
    top: 20%;
    transform: translateX(-50%);
  }

}

@media (max-width: 500px) {
  .HomeAccomp-Images {
    display: none;
  }

  .HomeAccomp-Container {
    padding-bottom: 0px;
  }
}
</style>